import { FC } from 'react';

import { useFormikContext } from 'formik';
import { Button } from 'ui/components/common';
import { Input } from 'ui/components/form';
import { SIZE } from 'utils/constants';

import { LOGIN_FORM } from './schema';

interface PROPS {
  isLoading?: boolean;
}

const AdminLoginForm: FC<PROPS> = ({ isLoading }) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormikContext<LOGIN_FORM>();

  return (
    <form onSubmit={handleSubmit}>
      <Input
        className="w-full mb-[12px]"
        type="text"
        name="emailAddress"
        size={SIZE.Large}
        textType={
          errors.emailAddress && touched.emailAddress ? 'danger' : 'default'
        }
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.emailAddress}
        placeholder="Email Address"
        subText={
          errors.emailAddress && touched.emailAddress
            ? errors.emailAddress
            : undefined
        }
        disabled={isSubmitting}
      />
      <div className="relative">
        <Input
          className="w-full"
          type="password"
          name="password"
          size={SIZE.Large}
          textType={errors.password && touched.password ? 'danger' : 'default'}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          placeholder="Password"
          subText={
            errors.password && touched.password ? errors.password : undefined
          }
          disabled={isSubmitting}
        />
      </div>
      <Button
        label="LOGIN"
        type="submit"
        size="lg"
        className="font-semibold w-full mt-[30px]"
        disabled={isSubmitting || isLoading}
      />
    </form>
  );
};

export default AdminLoginForm;
